export const addSeparateur = (nombre) => {
  if (nombre == null) {
    return nombre;
  }
  const str = nombre.toString();
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
